// Century City Connect packages
export const centuryCityPackages = [
  {
    ID: 3368859,
    Title: "Century City Connect 30/15Mbps FTTH - CCC By WonderNet",
    Price: 699.00,
    "Download speed (kbps)": 30720,
    "Upload speed (kbps)": 15360,
    Supplier: "Century City Connect",
    ISP: "Wondernet"
  },
  {
    ID: 3368866,
    Title: "Century City Connect 50/25Mbps FTTH - CCC By WonderNet",
    Price: 899.00,
    "Download speed (kbps)": 51200,
    "Upload speed (kbps)": 25600,
    Supplier: "Century City Connect",
    ISP: "Wondernet"
  },
  {
    ID: 3368869,
    Title: "Century City Connect 100/50Mbps FTTH - CCC By WonderNet",
    Price: 1099.00,
    "Download speed (kbps)": 102400,
    "Upload speed (kbps)": 51200,
    Supplier: "Century City Connect",
    ISP: "Wondernet"
  },
  {
    ID: 22506306,
    Title: "Century City Connect 100/100Mbps FTTH - CCC By WonderNet",
    Price: 1099.00,
    "Download speed (kbps)": 102400,
    "Upload speed (kbps)": 102400,
    Supplier: "Century City Connect",
    ISP: "Wondernet"
  }
];